"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSlugUrl = exports.toSlugUrl = void 0;
const web_log_1 = require("@snapchat/web-log");
/*
  Convert strings to slug e.g.
  - Cartoon kid -> Cartoon-kid
  - My cool-lens -> My-cool--lens
 */
const toSlugUrl = (query) => encodeURIComponent(query
    .toString()
    .trim()
    .replaceAll("-", "--") // Convert - to --
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/-+$/, "") // Trim - from end of slug
);
exports.toSlugUrl = toSlugUrl;
/*
  Convert slugs to string e.g.
  - Cartoon-kid -> Cartoon kid
  - My-cool--lens -> My cool-lens
 */
const fromSlugUrl = (slug) => {
    // if slug includes space, return original string
    if (slug.includes(" "))
        return slug;
    try {
        return decodeURIComponent(slug
            .split("--")
            .map((str) => str.replaceAll("-", " "))
            .join("-"));
    }
    catch (e) {
        web_log_1.log.error(`Error occured while decoding URI ${slug}`, e);
        return "";
    }
};
exports.fromSlugUrl = fromSlugUrl;
//# sourceMappingURL=slugify-url.js.map